export default function validateLength(value, length) {
  return value.length <= length
}
